export default {
    COM_REGIME: 1,
    AUTONOMO: 2,
    FUNCIONARIO_PUBLICO: 3,
    OUTRO: 4
}